import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import menuIcon from "../../assets/icons/menubar.png";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";

const menuItems = [
  { text: "Dashboard", path: "/gso/dashboard" },
  { text: "Lost Item Claim", path: "/gso/lost-items" },
  { text: "Found Item Record", path: "/gso/found-items" },
  { text: "Notifications", path: "/gso/notification" },
  { text: "Heatmap", path: "/gso/heatmap" },
];

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const index = menuItems.findIndex(item => item.path === currentPath);
    if (index !== -1) {
      setSelectedIndex(index);
    }
  }, [location.pathname]);

  const handleListItemClick = (event, index, path) => {
    setSelectedIndex(index);
    navigate(path);
    if (isMobile) {
      setTimeout(() => {
        toggleSidebar();
      }, 300);
    }
  };

  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={isMobile ? () => setTimeout(toggleSidebar, 300) : () => {}}
      variant={isMobile ? "temporary" : "persistent"}
      ModalProps={{
        BackdropProps: { invisible: true },
      }}
      sx={{
        width: isMobile ? 250 : 300,
        flexShrink: 0,
        transition: 'width 0.3s cubic-bezier(0.4,0,0.2,1)',
        bgcolor: '#FBFFE9',
        "& .MuiDrawer-paper": {
          width: isMobile ? 200 : 300,
          boxSizing: "border-box",
          bgcolor: "#FBFFE9",
          border: "none",
          boxShadow: "8px 0 32px 0 rgba(81, 109, 79, 0.12)",
          borderTopRightRadius: "12px",
          borderBottomRightRadius: "12px",
          transition: 'width 0.3s cubic-bezier(0.4,0,0.2,1)',
        },
      }}
    >
      {isOpen && (
        <Box sx={{ p: 1, display: "flex", alignItems: "center", mt: 1 }}>
          <IconButton 
            onClick={toggleSidebar} 
            sx={{ 
              color: "#516d4f", 
              ml: 4,
              padding: "8px"
            }}
          >
            <img 
              src={menuIcon} 
              alt="Menu" 
              style={{ 
                width: 32, 
                height: 32,
                display: 'block'
              }} 
            />
          </IconButton>
          <Typography
            variant="h5"
            sx={{
              flexGrow: 1,
              fontWeight: "bold",
              color: "#516d4f",
              ml: 2,
              fontSize: isMobile ? "1.2rem" : "1.5rem",
            }}
          >
            UFind
          </Typography>
        </Box>
      )}

      <List sx={{ mt: 2 }}>
        {menuItems.map((item, index) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              selected={selectedIndex === index}
              onClick={(event) => handleListItemClick(event, index, item.path)}
              sx={{
                py: 2,
                pl: 4,
                "&.Mui-selected": { bgcolor: "rgba(81, 109, 79, 0.08)" },
                "&:hover": { bgcolor: "rgba(81, 109, 79, 0.12)" },
              }}
            >
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  sx: {
                    fontWeight: "Bold",
                    fontSize: isMobile ? "16px" : "20px",
                    color: "#516d4f",
                    ml: 2,
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
